<template>
  <div>
    <nav-bar ref="form"/>
    <div class="sec-wight-bg py-16 ">
      <div class="container sec-garay-bg border-radius ">
        <div class="row ">
          <h5 class="text-blue col py-0">
            <page-title :titles="'مشاوره'"/>
          </h5>
        </div>
      </div>
      <div v-if="isPageLoaded" class="container py-16">
        <div class="row">
          <div class="col-12">
            <v-img class="img-fluid mx-auto" :src="$replaceHttps(PageContent.fileUrl)" height="300"></v-img>
          </div>
        </div>
        <div class="container">
          <div class="row sec-garay-bg">
            <div class="col " v-html="PageContent.description"></div>
          </div>
        </div>
      </div>
      <div class="contact-form-wrapper" v-if="isPageLoaded">
        <div class="container sec-garay-bg">
          <div class="  py-3 ">
            <div class="container  border-radius ">
              <div class="row ">
                <h5 class="text-blue col py-0 text-center">
                  فرم ارسال پیام
                </h5>
              </div>
            </div>
          </div>
          <v-form ref="form">
            <div class="row">
              <div class="col-12">
                <v-text-field solo flat v-model="name" placeholder="نام و نام خانوادگی"
                              :rules="required"
                ></v-text-field>
              </div>
              <div class="col-12">
                <v-text-field solo flat v-model="phoneNumber" type="number" placeholder="شماره موبایل"
                              :rules="phoneRules"></v-text-field>
              </div>
              <div class="col-12">
                <v-textarea solo flat v-model="massage" placeholder="توضیحات" :rules="required"


                ></v-textarea>
              </div>
              <div class="col-12">
                <v-btn
                    block
                    color="secondary"
                    elevation="0"
                    @click="PostBusinessForm"
                >
                  ارسال پیام
                </v-btn>
              </div>
            </div>
          </v-form>
        </div>
      </div>

      <v-dialog
          v-model="showResultDialog"
          hide-overlay
          persistent
          width="500">
        <v-card class="text-center">
          <v-card-title class="justify-space-between bg-Products ">
            <v-btn
                class="mr-2"
                icon
                @click="showResultDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pt-6">
            <div class="mb-0 black&#45;&#45;text py-5">{{ dialogResult }}</div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <footer-menu></footer-menu>
    <v-overlay
        id="searchOverLay"
        :absolute="false"
        :color="'#f7f1fc'"
        :opacity="0.7"
        :value="showLoaderDialog"
        :z-index="6">
      <div class="row h-100 align-items-center justify-content-center">
        <div class="loading-spinner">
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import FooterMenu from "@/components/footer";
import PageTitle from "@/components/titles";

export default {
  name: "conferencePage",
  components: {PageTitle, FooterMenu, NavBar},
  metaInfo: {
    title: 'ماشین سازان اصلانیان-مشاوره'
  },
  data: () => ({
    showLoaderDialog: false,
    isPageLoaded: false,
    PageContent: null,
    name: null,
    phoneNumber: null,
    massage: null,
    phoneRules: [
      v => !!v || "پر کردن این فیلد الزامی است",
      v => (v && v.length === 11) || 'تلفن 11 رقم است.',
    ],
    required: [v => !!v || "پر کردن این فیلد الزامی است"],
    dialogResult: null,

    showResultDialog: false
  }),
  mounted() {
    this.getData()

  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },


    PostBusinessForm() {

      this.$refs.form.validate()
      if (this.$refs.form.validate()) {


        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("MobileNumber", this.phoneNumber);
        urlencoded.append("Description", this.massage);
        urlencoded.append("NameAndFamily", this.name);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

        fetch("https://api.aslanianmachine.com/Home/PostBusinessForm", requestOptions)
            .then(response => response.text())
            .then(result => {

              this.dialogResult = result
              this.showResultDialog = true
            })
            .catch(error => console.log('error', error));
      }
    },


    getData() {
      this.showLoaderDialog = true;
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };


      fetch(this.$baseUrl + "Home/PageContent?TypePage=7", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.PageContent = JSON.parse(result)
            this.isPageLoaded = true
            this.showLoaderDialog = false;
          })
          .catch(error => console.log('error', error));
    },

  }
}
</script>

<style scoped>

</style>